import { developerConstants } from '../constants/developer.constants';

const initialState = {
  // Developer stats
  isFetchingStats: false,
  stats: {},

  // Developer profile
  isFetchingProfile: false,
  isUpdatingProfile: false,
  profile: null,

  // Published apps stats
  isFetchingPublishedAppsStats: false,
  publishedAppsStats: {},

  // App analytics
  isFetchingAppAnalytics: false,
  appAnalytics: {},

  // Revenue stats
  isFetchingRevenueStats: false,
  revenueStats: {},

  error: null,
};

export default function developer(state = initialState, action) {
  switch (action.type) {
    case developerConstants.DEVELOPER_CHANGE_VALUE:
      return { ...state, error: '', [action.name]: action.value };

    // Developer stats
    case developerConstants.GET_DEVELOPER_STATS_STARTED:
      return { ...state, isFetchingStats: true };
    case developerConstants.GET_DEVELOPER_STATS_FAILURE:
      return { ...state, isFetchingStats: false, stats: {}, error: action.message || '' };
    case developerConstants.GET_DEVELOPER_STATS_SUCCESS:
      return {
        ...state,
        isFetchingStats: false,
        stats: action.stats || {},
      };

    // Developer profile
    case developerConstants.GET_DEVELOPER_PROFILE_STARTED:
      return { ...state, isFetchingProfile: true };
    case developerConstants.GET_DEVELOPER_PROFILE_FAILURE:
      return { ...state, isFetchingProfile: false, profile: null, error: action.message || '' };
    case developerConstants.GET_DEVELOPER_PROFILE_SUCCESS:
      return {
        ...state,
        isFetchingProfile: false,
        profile: action.profile || null,
      };

    case developerConstants.UPDATE_DEVELOPER_PROFILE_STARTED:
      return { ...state, isUpdatingProfile: true };
    case developerConstants.UPDATE_DEVELOPER_PROFILE_FAILURE:
      return { ...state, isUpdatingProfile: false, error: action.message || '' };
    case developerConstants.UPDATE_DEVELOPER_PROFILE_SUCCESS:
      return {
        ...state,
        isUpdatingProfile: false,
        profile: action.profile || state.profile,
      };

    // Published apps stats
    case developerConstants.GET_PUBLISHED_APPS_STATS_STARTED:
      return { ...state, isFetchingPublishedAppsStats: true };
    case developerConstants.GET_PUBLISHED_APPS_STATS_FAILURE:
      return { ...state, isFetchingPublishedAppsStats: false, publishedAppsStats: {}, error: action.message || '' };
    case developerConstants.GET_PUBLISHED_APPS_STATS_SUCCESS:
      return {
        ...state,
        isFetchingPublishedAppsStats: false,
        publishedAppsStats: action.stats || {},
      };

    // App analytics
    case developerConstants.GET_APP_ANALYTICS_STARTED:
      return { ...state, isFetchingAppAnalytics: true };
    case developerConstants.GET_APP_ANALYTICS_FAILURE:
      return { ...state, isFetchingAppAnalytics: false, error: action.message || '' };
    case developerConstants.GET_APP_ANALYTICS_SUCCESS:
      return {
        ...state,
        isFetchingAppAnalytics: false,
        appAnalytics: {
          ...state.appAnalytics,
          [action.appId]: action.analytics || {}
        }
      };

    // Revenue stats
    case developerConstants.GET_REVENUE_STATS_STARTED:
      return { ...state, isFetchingRevenueStats: true };
    case developerConstants.GET_REVENUE_STATS_FAILURE:
      return { ...state, isFetchingRevenueStats: false, revenueStats: {}, error: action.message || '' };
    case developerConstants.GET_REVENUE_STATS_SUCCESS:
      return {
        ...state,
        isFetchingRevenueStats: false,
        revenueStats: action.stats || {},
      };

    default:
      return state;
  }
}